import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';
import * as DropdownStyled from 'theme/components/Dropdown.style';
import * as SelectionStyled from 'theme/components/SelectionDropdown.style';
import * as Styled from '../../styles/FilterGroupingControl.style';
import { DepartmentOption } from './_types';

interface DepartmentFilterMenuProps {
  departments: DepartmentOption[];
  selected: string | null;
  onSelect: (id: string | null) => void;
  topOffset?: number;
}

export default function DepartmentFilterMenu({
  departments,
  selected,
  onSelect,
  topOffset,
}: DepartmentFilterMenuProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.PopoverCard $zIndex={1400} $topOffset={topOffset} $leftOffset={-40}>
      <Styled.List>
        <DropdownStyled.SectionHeader>
          {t('filterGrouping.department.title')}
        </DropdownStyled.SectionHeader>
        {departments.map((department) => {
          const isSelected = selected === department.id;
          return (
            <SelectionStyled.Option
              key={department.id}
              type="button"
              $selected={isSelected}
              onClick={() => onSelect(isSelected ? null : department.id)}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <span>{department.name}</span>
              <SelectionStyled.OptionCheck $selected={isSelected}>
                {isSelected && <General.Check size={16} />}
              </SelectionStyled.OptionCheck>
            </SelectionStyled.Option>
          );
        })}
      </Styled.List>
    </Styled.PopoverCard>
  );
}
